import {
  CheckCertificate,
  CourseConstants as Constants,
  CourseProgress,
  DownloadCertificate,
  RESET_MY_COURSE,
} from "../constants";
const initialState = {
  courses: [],
  course: {},
  featured: [],
  my_courses: [],
  my_course: null,
  loading: false,
  checkCertificationLoader: false,
  courseProgressLoader: false,
};

export function courseReducer(state = initialState, action) {
  switch (action.type) {
    case Constants.ALL:
      return {
        ...state,
        courses: action.payload.courses,
      };

    case Constants.GET:
      return {
        ...state,
        course: action.payload,
      };

    case Constants.MY_COURSE_DETAIILS:
      return {
        ...state,
        my_course: action.payload.course,
      };

    case Constants.MY_COURSES:
      return {
        ...state,
        my_courses: action.payload.courses,
      };

    case Constants.FEATURED:
      return {
        ...state,
        featured: action.payload.courses,
      };

    case Constants.FAILED:
      return {
        ...state,
      };

    case Constants.CLEAR:
      return {
        courses: [],
      };

    case Constants.BUY_COURSE:
      return {
        ...state,
      };

    case Constants.CLEAR_ONE:
      return {
        course: {},
      };

    case DownloadCertificate.DOWNLOAD_LOADING:
      return {
        ...state,
        loading: true,
      };

    case DownloadCertificate.DOWNLOAD_CERTIFICATE:
      return {
        ...state,
        loading: false,
      };

    case DownloadCertificate.FAILED:
      return {
        ...state,
        loading: false,
      };

    case CheckCertificate.LOADING:
      return {
        ...state,
        checkCertificationLoader: true,
      };

    case CheckCertificate.CHECK_CERTIFICATE:
      return {
        ...state,
        checkCertificationLoader: false,
      };

    case CheckCertificate.FAILED:
      return {
        ...state,
        checkCertificationLoader: false,
      };

    case CourseProgress.COURSE_PROGRESS_LOADING:
      return {
        ...state,
        courseProgressLoader: true,
      };

    case CourseProgress.COURSE_PROGRESS:
      return {
        ...state,
        courseProgressLoader: false,
      };

    case CourseProgress.COURSE_PROGRESS_FAILED:
      return {
        ...state,
        courseProgressLoader: false,
      };

    case RESET_MY_COURSE:
      return {
        ...state,
        my_course: null,
      };

    default:
      return state;
  }
}
